export default __webpack_public_path__ + "static/media/ASP.c58c9805.webp";